// extracted by mini-css-extract-plugin
export default {"video-wrapper":"CM0K8C4yEBxsl5fv2zrxTg==","native-video":"zli0+vEg69cZSUTgcRTs3g=="};